import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Daily from './daily';
import Weekly from './weekly';
import Addoptions from './addoption';//CheckBox Options
import AddMultipleQuestions from './addMultipleQuestions'; //Multiple  Options - in this questions.js file is using
import { bindActionCreators } from 'redux';
import * as QuestionnaireActions from '../../actions/questionnaire_actions';
import Header from '../../components/header';
let screenIdentifier = 'questionnaire';
import { ModalDialogCommon } from '../modal_dialog_common';
import _ from 'lodash';
import { validate } from '../../validations';

let Questionnaire = React.createClass({
    getInitialState() {
        return {
            //options daily weekly tabs selections
            selectedTab: '0',
            //Dropdwon selected  Sub-Question Type
            selectedSubQuestionType: '0',
            previouslySelectedSubQuestionType: 0,
            previouslyEditClickedQuestionId: null,
            // Sub Question  Check Box Options
            checkBoxOptions: [],
            // Sub Question Multiple  Options
            multiOptions: [],
            // selected silder Options   and Send to Create API
            MinValuesSlider: '', //min value
            MaxValuesSlider: '',//max value
            MidvaluesSlider: '',
            MaxValuesSliderOpt: '', //min value name
            MinValuesSliderOpt: '',// max value name
            MidvaluesSliderOpt: '',
            //silder Options end

            // handeling editquestion for all buttons
            addQuestionBool: false,
            //Ok Modal Popup
            showModal: false,
            // To set dropdown selected options
            selectedIcon: null,
            selectedLabel: "Select Options",
            //QuestionData sending Create APi
            QuestionData: null,

            //validations
            errorMessage: null,
            //save Modal

            //savedQuestionDeletModal
            conformationModalMessage: null,
            conformationModalType: null,
            savedQuestiondeletId: null,
            //Ok Model errorMessage
            Okmessage: null,
            counter: 0, comrifmClicked: false,
            //Arrary of Object selected Label and Icon
            selectedIconAndIconLabel: [{ "icon": "", "iconLabel": "Select Options" },
            { 'icon': "icon-time", 'iconLabel': "Time" },
            { 'icon': "icon-date", 'iconLabel': "Date" },
            { 'icon': "icon-checkbox", 'iconLabel': "Checkbox" },
            { 'icon': "icon-paragraph", 'iconLabel': "Paragraph" },
            { 'icon': "icon-short-answer", 'iconLabel': "Short Answer" },
            { 'icon': "icon-multiple-choice", 'iconLabel': "Multiple Choice" },
            { 'icon': "icon-slider", 'iconLabel': "Slider" }],
            isQuestionEdit: true
        }
    },
    componentWillMount() {

        this.props.Dispatch(QuestionnaireActions.questionnaire());
        this.props.Dispatch(QuestionnaireActions.anserType());
        this.setState({ isHappyImage: <img src={require('./../../images/happy.png')} />, issadImage: <img src={require('./../../images/sad.png')} /> })
        //   console.log(this.state.addQuestionBool, 'background: #222; color: #bada55');
    },
    componentDidMount() {
        //  console.log(this.state.addQuestionBool, 'background: #222; color: #bada55');
        // this.props.Dispatch(QuestionnaireActions.questionnaire());
        // this.props.Dispatch(QuestionnaireActions.anserType());
    },
    componentWillReceiveProps(nextProps) {
        this.setState({
            editQuestion: false, selectedSubQuestionType: '0', previouslySelectedSubQuestionType: 0, QuestionData: null, checkBoxOptions: [],
            multiOptions: [], addQuestionBool: (!(nextProps.uniqe && nextProps.uniqe.length)), MidvaluesSlider: ""
        })
        if (this.state.comrifmClicked) {

            this.setState({
                addQuestionBool: (!(nextProps.uniqe && nextProps.uniqe.length)), comrifmClicked: false, MidvaluesSlider: ""
            })
        }
        //  addQuestionBool: (!(nextProps.uniqe && nextProps.uniqe.length)),
    },

    // Tab Selection
    storeTypeHandler(e) {
        this.setState({ selectedTab: e.target.value });
    },

    // To edit the Question
    onEditClick(e) {
        this.setState({ isQuestionEdit: false });
        if (this.state.addQuestionBool) {
            this.setState({ previouslyEditClickedQuestionId: e.currentTarget.dataset.val });
            this.setState({ conformationModalMessage: 'Another question(s) is in unsaved state. Are you sure you want to discard the changes?', conformationModalType: 'DiscardUnSavedQuestion' });
            return false;
        }
        var selectedEdit = (_.filter(this.props.uniqe, (i) => { return e.currentTarget.dataset.val == i.id }))[0];
        this.setState({ addQuestionBool: true, editQuestion: selectedEdit, selectedLabel: this.state.selectedIconAndIconLabel[selectedEdit.answerType.id].iconLabel, selectedIcon: this.state.selectedIconAndIconLabel[selectedEdit.answerType.id].icon, }, () => {
            this.setEditQuestion();
        });

    },
    midvaluesSlider() {
        if (this.state.MidvaluesSlider != '') {
            return this.state.MidvaluesSlider
        }
        if (this.state.MaxValuesSlider && this.state.MinValuesSlider) {
            let x = Math.ceil((parseInt(this.state.MinValuesSlider) + parseInt(this.state.MaxValuesSlider)) / 2);
            this.setState({ MidvaluesSlider: x })
            return x;
        }
        else {
            return '';
        }
    },
    // To edit the Question - Previously Clicked
    onPreviousEditClick() {
        this.setState({ previouslySelectedSubQuestionType: 0, selectedSubQuestionType: '0' });
        var selectedEdit = (_.filter(this.props.uniqe, (i) => { return this.state.previouslyEditClickedQuestionId == i.id }))[0];
        this.setState({ addQuestionBool: true, editQuestion: selectedEdit, selectedLabel: this.state.selectedIconAndIconLabel[selectedEdit.answerType.id].iconLabel, selectedIcon: this.state.selectedIconAndIconLabel[selectedEdit.answerType.id].icon, }, () => {

            this.setEditQuestion();
        });

        this.setState({ previouslyEditClickedQuestionId: null });
    },

    // To set the Edit Question
    setEditQuestion() {
        document.body.scrollTop = document.documentElement.scrollTop = 0; // to scroll to top in samll screen
        this.setState({ previouslySelectedSubQuestionType: this.state.editQuestion.answerType.id.toString() });
        var data = { selectedSubQuestionType: this.state.editQuestion.answerType.id.toString() };
        this.refs.mainQuestion.value = this.state.editQuestion.name;
        switch (data.selectedSubQuestionType) {
            case '3':
                data.checkBoxOptions = this.state.editQuestion.answer;
                break;
            case '6':
                data.multiOptions = this.state.editQuestion.answer;
                console.log(data.multiOptions);
                break;
            case '7':
                console.log(this.state.editQuestion);
                var val = this.state.editQuestion.sliderConfiguration[0];
                var val1 = this.state.editQuestion.sliderConfiguration[1];
                var val2 = this.state.editQuestion.sliderConfiguration[2];
                var val3 = this.state.editQuestion.sliderConfiguration[3];
                var val4 = this.state.editQuestion.sliderConfiguration[4];
                var val5 = this.state.editQuestion.sliderConfiguration[5];
                var val6 = this.state.editQuestion.sliderConfiguration[6];
                data.MaxValuesSlider = val2.data;
                data.MaxValuesSliderOpt = val2.value;
                data.MidvaluesSlider = val1.data;
                data.MidValuesSliderOpt = val1.value;
                data.MinValuesSlider = val.data;
                data.MinValuesSliderOpt = val.value;

                data.dailyServeyValue = val3 && val3.data;
                data.dailyServeyValueOpt = val3 && val3.value;
                data.dailyServeyOneValue = val4 && val4.data;
                data.dailyServeyOneValueOpt = val4 && val4.value;

                data.dailyServeyTwoValue = val5 && val5.data;
                data.dailyServeyTwoValueOpt = val5 && val5.value;

                data.dailyServeyThreeValue = val6 && val6.data;
                data.dailyServeyThreeValueOpt = val6 && val6.value;

                break;
        }
        this.setState(data)
    },

    isValidQuestion() {
        var data;


        let isValidMainQuestion = validate.name(this.refs.mainQuestion);

        isValidMainQuestion ? this.refs.mainQuestion.className = 'inputText' : this.refs.mainQuestion.className = 'inputText error';



        if (isValidMainQuestion) {
            data = {
                "questions": [{
                    "name": this.refs.mainQuestion.value,
                    "type": "DAILY",
                    "answerType": {
                        "id": this.state.selectedSubQuestionType,
                    }
                }]
            }

            if (this.state.selectedSubQuestionType === '0') {
                this.setState({
                    Okmessage: "Please select the answer type to proceed.",

                })
            }

            if (this.state.selectedSubQuestionType === '1' || this.state.selectedSubQuestionType === '2' || this.state.selectedSubQuestionType === '4' || this.state.selectedSubQuestionType === '5') {
                this.setState({
                    conformationModalMessage: 'Are you sure you want to save question(s)?',
                    conformationModalType: 'saveQuestionModal',
                })
            }
            this.setState({
                errorMessage: null,
                QuestionData: data
            })

        } else {
            this.setState({
                errorMessage: 'Please enter necessary fields to proceed.',
            })
            //return false;
        }
        console.log(this.state.selectedSubQuestionType, 'selected type')
        switch (this.state.selectedSubQuestionType) {
            case '3':
                var isAllCheckboxsHasValues = true;
                for (let i = 0; i < this.refs.checkBoxOptions.children.length; i++) {
                    var isValidCheckBox = validate.name(this.refs.checkBoxOptions.children[i].firstElementChild.firstElementChild.children[1]);
                    isValidCheckBox ? this.refs.checkBoxOptions.children[i].firstElementChild.firstElementChild.children[1].className = 'update-mail' : this.refs.checkBoxOptions.children[i].firstElementChild.className = 'error-border-bottom';
                    if (!isValidCheckBox) {
                        isAllCheckboxsHasValues = false
                        this.setState({ conformationModalType: null });
                    }
                }
                if (data && isValidCheckBox && isAllCheckboxsHasValues) {
                    data.questions[0].answer = this.state.checkBoxOptions;
                    this.setState({
                        errorMessage: null,
                        conformationModalMessage: 'Are you sure you want to save question(s)?',
                        conformationModalType: 'saveQuestionModal',
                        QuestionData: data
                    })
                }
                else {
                    this.setState({ errorMessage: 'Please enter necessary fields to proceed.' });
                }

                break;
            case '6':
                // Sub Questions validataions
                let isAllMultipleHasValues = true;
                let isAllFollowupQuestionsHasOptionTypes = true;

                for (let i = 0; i < this.refs.multipleOptions.children.length; i++) {

                    // validation for sub-question text
                    var isValidMultipleOptions = validate.name(this.refs.multipleOptions.children[i].firstElementChild.firstElementChild.children[1]);
                    isValidMultipleOptions ? this.refs.multipleOptions.children[i].firstElementChild.firstElementChild.children[1].className = 'update-mail' : this.refs.multipleOptions.children[i].firstElementChild.firstElementChild.children[2] ? this.refs.multipleOptions.children[i].firstElementChild.firstElementChild.children[2].parentElement.parentElement.className = 'error-border-bottom' : this.refs.multipleOptions.children[i].firstElementChild.firstElementChild.children[1].parentElement.parentElement.className = 'error-border-bottom';
                    if (!isValidMultipleOptions) {
                        isAllMultipleHasValues = false
                    }

                    // if followup question exists ?
                    if (this.refs.multipleOptions.children[i].children[1] != undefined) {
                        //validations for followup Question
                        var isValidFollowupQuestion = validate.name(this.refs.multipleOptions.children[i].children[1].children[0].children[0].children[1]);
                        isValidFollowupQuestion ? this.refs.multipleOptions.children[i].children[1].children[0].children[0].children[1].className = 'follow-text' : this.refs.multipleOptions.children[i].children[1].children[0].children[0].children[1].className = 'follow-text error-border-bottom';

                        if (!isValidFollowupQuestion) {
                            isAllMultipleHasValues = false;
                        }


                        if (this.state.multiOptions[i] && this.state.multiOptions[i].followQuestion && this.state.multiOptions[i].followQuestion[0].answerType && this.state.multiOptions[i].followQuestion[0].answerType.id) {
                            //  console.log('this.state.multiOptions[i].followQuestion.answerType.id : ', this.state.multiOptions[i].followQuestion[0].answerType.id);
                            let followUpQuestionOptionsType = this.state.multiOptions[i].followQuestion[0].answerType.id;

                            // FollowUpQuestionOptionsType validation
                            if (followUpQuestionOptionsType != 0) {
                                //validation for followup Question type Check boxes and multiple choice options
                                if (followUpQuestionOptionsType == 3 || followUpQuestionOptionsType == 6) {

                                    //this.refs.multipleOptions.children[i].children[1].children[0].children[1].   .children[0].children[0].children[0].children[0].children[0].children[0].children[0].children[1]
                                    for (let j = 0; j < this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children.length; j++) {

                                        if (this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[j].className != 'addmoretext') {
                                            var isValidFollowupQuestionOptionValue = validate.name(this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[j].children[0].children[0].children[1]);
                                            isValidFollowupQuestionOptionValue ? this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[j].children[0].className = '' : this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[j].children[0].className = 'error-border-bottom';

                                            if (!isValidFollowupQuestionOptionValue) {
                                                isAllMultipleHasValues = false;
                                            }
                                        }
                                    }
                                }

                                // validation for followup question type - Slider
                                if (followUpQuestionOptionsType == 7) {
                                    // Slider MinValue validataion
                                    let isValidFollowupQuestionSliderMinValue = validate.notEmpty(this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[0].children[0].value);
                                    isValidFollowupQuestionSliderMinValue ? this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[0].children[0].className = 'slider-value' : this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[0].children[0].className = 'slider-value error-border-bottom';

                                    // Slider MinValue Description validataion
                                    let isValidFollowupQuestionSliderMinValueDescription = validate.name(this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[0].children[1]);
                                    isValidFollowupQuestionSliderMinValueDescription ? this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[0].children[1].className = 'update-mail' : this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[0].children[1].className = 'update-mail error-border-bottom';

                                    // Slider MaxValue validataion
                                    let isValidFollowupQuestionSliderMaxValue = validate.notEmpty(this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[1].children[0].value);
                                    isValidFollowupQuestionSliderMaxValue ? this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[1].children[0].className = 'slider-value' : this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[1].children[0].className = 'slider-value error-border-bottom';

                                    // Slider MaxValue Description validataion
                                    let isValidFollowupQuestionSliderMaxValueDescription = validate.name(this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[1].children[1]);
                                    isValidFollowupQuestionSliderMaxValueDescription ? this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[1].children[1].className = 'update-mail' : this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[1].children[1].className = 'update-mail error-border-bottom';
                                    // Slider MidValue validataion
                                    let isValidFollowupQuestionSliderMidValue = validate.notEmpty(this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[0].children[0].value);
                                    isValidFollowupQuestionSliderMidValue ? this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[0].children[0].className = 'slider-value' : this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[0].children[0].className = 'slider-value error-border-bottom';
                                    //Slider MaxValue Description validataion
                                    let isValidFollowupQuestionSliderMidValueDescription = validate.name(this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[0].children[1]);
                                    isValidFollowupQuestionSliderMidValueDescription ? this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[0].children[1].className = 'update-mail' : this.refs.multipleOptions.children[i].children[1].children[0].children[1].children[0].children[0].children[0].children[0].children[2].children[0].children[1].className = 'update-mail error-border-bottom';
                                    if (!isValidFollowupQuestionSliderMinValue || !isValidFollowupQuestionSliderMinValueDescription || !isValidFollowupQuestionSliderMaxValue || !isValidFollowupQuestionSliderMaxValueDescription || !isValidFollowupQuestionSliderMidValue || !isValidFollowupQuestionSliderMidValueDescription) {
                                        isAllMultipleHasValues = false;
                                    }
                                }
                            }
                            else {
                                isAllFollowupQuestionsHasOptionTypes = false;
                                this.setState({ Okmessage: "Please select the follow up question answer type to proceed." });
                            }

                        }

                    }

                }


                if (data && isAllMultipleHasValues && isAllFollowupQuestionsHasOptionTypes) {
                    data.questions[0].answer = this.state.multiOptions;
                    this.setState({
                        errorMessage: null,
                        conformationModalMessage: 'Are you sure you want to save question(s)?',
                        conformationModalType: 'saveQuestionModal',
                        QuestionData: data
                    })
                }
                else if (data && isAllMultipleHasValues && !isAllFollowupQuestionsHasOptionTypes) {
                    this.setState({
                        Okmessage: "Please select the follow up question answer type to proceed.",

                    })
                }

                else {
                    this.setState({
                        errorMessage: 'Please enter necessary fields to proceed.',

                    })
                }

                break;
            case '7':
                let isValidSliderMinAns = validate.name(this.refs.sliderMinanswer);
                isValidSliderMinAns ? this.refs.sliderMinanswer.className = 'update-mail' : this.refs.sliderMinanswer.className = 'update-mail error-border-bottom';

                let isValidSliderMaxAns = validate.name(this.refs.sliderMaxanswer);
                isValidSliderMaxAns ? this.refs.sliderMaxanswer.className = 'update-mail' : this.refs.sliderMaxanswer.className = 'update-mail error-border-bottom';

                let isValidSliderMidAns = validate.name(this.refs.sliderMidanswer);
                isValidSliderMidAns ? this.refs.sliderMidanswer.className = 'update-mail' : this.refs.slidederMidanswer.className = 'update-mail error-border-bottom';

                let isValidSliderMaxValue = validate.notEmpty(this.refs.sliderMaxValue.value);
                isValidSliderMaxValue ? this.refs.sliderMaxValue.className = 'slider-value' : this.refs.sliderMaxValue.className = 'slider-value error-border-bottom';

                let isValidSliderMinValue = validate.notEmpty(this.refs.sliderMinValue.value);
                isValidSliderMinValue ? this.refs.sliderMinValue.className = 'slider-value' : this.refs.sliderMinValue.className = 'slider-value error-border-bottom';

                let isValidSliderMidValue = validate.notEmpty(this.refs.sliderMidValue.value);
                isValidSliderMidValue ? this.refs.sliderMidValue.className = 'slider-value' : this.refs.sliderMidValue.className = 'slider-value error-border-bottom';

                // let isDailySliderValue = validate.notEmpty(this.refs.dailySliderValue.value);
                // isDailySliderValue ? this.refs.dailySliderValue.className = 'slider-value' : this.refs.dailySliderValue.className = 'slider-value error-border-bottom';

                // let isValidDailySliderValueAns = validate.name(this.refs.dailySliderValueanswer);
                // isValidDailySliderValueAns ? this.refs.dailySliderValueanswer.className = 'update-mail' : this.refs.dailySliderValueanswer.className = 'update-mail error-border-bottom';


                // let isDailySliderValueOne = validate.notEmpty(this.refs.dailySliderValueOne.value);
                // isDailySliderValueOne ? this.refs.dailySliderValueOne.className = 'slider-value' : this.refs.dailySliderValueOne.className = 'slider-value error-border-bottom';

                // let isValidDailySliderValueOneAns = validate.name(this.refs.dailySliderValueOneanswer);
                // isValidDailySliderValueOneAns ? this.refs.dailySliderValueOneanswer.className = 'update-mail' : this.refs.dailySliderValueOneanswer.className = 'update-mail error-border-bottom';

                // let isDailySliderValueTwo = validate.notEmpty(this.refs.dailySliderValueTwo.value);
                // isDailySliderValueTwo ? this.refs.dailySliderValueTwo.className = 'slider-value' : this.refs.dailySliderValueTwo.className = 'slider-value error-border-bottom';

                // let isValidDailySliderValueTwoAns = validate.name(this.refs.dailySliderValueTwoanswer);
                // isValidDailySliderValueTwoAns ? this.refs.dailySliderValueTwoanswer.className = 'update-mail' : this.refs.dailySliderValueTwoanswer.className = 'update-mail error-border-bottom';

                // let isDailySliderValueThree = validate.notEmpty(this.refs.dailySliderValueThree.value);
                // isDailySliderValueThree ? this.refs.dailySliderValueThree.className = 'slider-value' : this.refs.dailySliderValueThree.className = 'slider-value error-border-bottom';

                // let isValidDailySliderValueThreeAns = validate.name(this.refs.dailySliderValueThreeanswer);
                // isValidDailySliderValueThreeAns ? this.refs.dailySliderValueThreeanswer.className = 'update-mail' : this.refs.dailySliderValueThreeanswer.className = 'update-mail error-border-bottom';


                // if (data && isValidSliderMaxValue && isValidSliderMinValue && isValidSliderMidValue && isDailySliderValue && isValidSliderMinAns && isValidSliderMaxAns && isValidSliderMidAns
                //     && isValidDailySliderValueAns && isDailySliderValueOne && isValidDailySliderValueOneAns && isDailySliderValueTwo && isValidDailySliderValueTwoAns &&
                //     isDailySliderValueThree && isValidDailySliderValueThreeAns)

                if (data && isValidSliderMaxValue && isValidSliderMinValue && isValidSliderMidValue && isValidSliderMinAns && isValidSliderMaxAns && isValidSliderMidAns) {
                    data.questions[0].sliderConfiguration = [{ "data": this.refs.sliderMinValue.value, "value": this.refs.sliderMinanswer.value },
                    { "data": this.refs.sliderMidValue.value, "value": this.refs.sliderMidanswer.value },
                    { "data": this.refs.sliderMaxValue.value, "value": this.refs.sliderMaxanswer.value },
                        // { "data": this.refs.dailySliderValue.value, "value": this.refs.dailySliderValue.value },
                        // { "data": this.refs.dailySliderValueOne.value, "value": this.refs.dailySliderValueOne.value },
                        // { "data": this.refs.dailySliderValueTwo.value, "value": this.refs.dailySliderValueTwo.value },
                        // { "data": this.refs.dailySliderValueThree.value, "value": this.refs.dailySliderValueThree.value }
                    ];

                    this.setState({
                        errorMessage: null,
                        conformationModalMessage: 'Are you sure you want to save question(s)?',
                        conformationModalType: 'saveQuestionModal',
                        QuestionData: data
                    })
                }
                else {
                    this.setState({
                        errorMessage: 'Please enter necessary fields to proceed. ',

                    })
                }
                break;
        }
    },

    // Sub Question Type changed
    answerTypeHandler(e) {
        if (this.state.previouslySelectedSubQuestionType == e.target.dataset.value) {
            return;
        }
        this.setState({
            checkBoxOptions: [],
            multiOptions: [],
            previouslySelectedSubQuestionType: e.target.dataset.value,
            selectedSubQuestionType: e.target.dataset.value,
            selectedIcon: this.state.selectedIconAndIconLabel[e.target.dataset.value].icon,
            selectedLabel: this.state.selectedIconAndIconLabel[e.target.dataset.value].iconLabel,
            MinValuesSlider: null,
            MaxValuesSlider: null, counter: 0
        });

        // Main Question Validataion
        if (!validate.name(this.refs.mainQuestion)) {
            if (this.state.errorMessage) {
                this.refs.mainQuestion.className = 'inputText error';
                this.setState({ errorMessage: 'Please enter necessary fields to proceed.' });
            }
        } else {
            this.setState({ errorMessage: null });
            this.refs.mainQuestion.className = 'inputText'
        }
        // add default child
        if (e.target.dataset.value == 3) {
            this.onAddChild();
        }

        // To add default child
        if (e.target.dataset.value == 6) {
            this.onAddChildmulti();
        }
    },

    addMoreQuestions(e) {
        if (this.state.addQuestionBool) {
            return false;
        }
        this.setState({
            addQuestionBool: true,
            selectedSubQuestionType: '0',
            showHideQuestions: false,
            selectedIcon: false,
            selectedLabel: "Select Options",
            MaxValuesSliderOpt: '',
            MinValuesSliderOpt: '', counter: 0, MidValuesSliderOpt: ''

        });

        // this.refs.mainQuestion.value = ''
    },

    /* start Options choice related functions passed for component */
    // To add checkboxes only
    onAddChild() {
        if (this.state.checkBoxOptions.length < 5) {
            let checkBoxOptions = this.state.checkBoxOptions.slice();
            checkBoxOptions.push({ name: "" });
            this.setState({
                checkBoxOptions: checkBoxOptions
            });
        }
    },

    // checkbox options -- added to checkBoxOptions variable
    onOptionChange(ans, idx) {
        var checkBoxOptions = this.state.checkBoxOptions.slice();
        checkBoxOptions[idx].name = ans;
        this.state.checkBoxOptions = checkBoxOptions;
    },

    // checkbox option delete
    deletRow(idx) {
        var checkBoxOptions = this.state.checkBoxOptions.slice();
        checkBoxOptions.splice(idx, 1)
        this.setState({
            checkBoxOptions: checkBoxOptions
        });
    },
    /* End Options choice related functions passed for component */

    /* Start Multiple choice related functions passed for component */
    onAddChildmulti() {
        if (this.state.multiOptions.length < 5) {
            var multiOptions = this.state.multiOptions.slice();
            multiOptions.push({ name: "" });
            this.setState({
                multiOptions: multiOptions,
                counter: this.state.counter + 1
            });
        }
    },
    onOptionChangeMulti(options, idx) {
        let x = this.state.multiOptions.slice();
        x[idx] = options;
        this.setState({
            multiOptions: x
        });
    },
    deletRowMultiQuestion(idx) {
        if (this.state.counter > 1) {
            var multiOptions = this.state.multiOptions.slice();
            multiOptions.splice(idx, 1)
            this.setState({
                counter: this.state.counter - 1
            })
            this.setState({
                multiOptions: multiOptions
            });
        }
    },
    /* End Multiple choice related functions passed for component */

    //delet saved question
    deleteSavedQuestionModal(e) {
        var data = e.target.dataset.value
        this.setState({ conformationModalType: 'deleteSavedQuestionModal', conformationModalMessage: "Are you sure you want to delete question(s)?", savedQuestiondeletId: data, selectedLabel: "Select Options", selectedIcon: false, });

    },

    onConfirm() {
        // delete Saved Question

        this.setState({ comrifmClicked: true });
        if (this.state.conformationModalType === 'deleteSavedQuestionModal') {
            this.props.Dispatch(QuestionnaireActions.deleteUQestions(this.state.savedQuestiondeletId));
            this.setState({ conformationModalMessage: null });
        }
        //  Save Question
        if (this.state.conformationModalType === 'saveQuestionModal') {
            this.props.Dispatch(QuestionnaireActions.questionnaire());
            if (this.state.editQuestion) {
                this.state.QuestionData.questions[0].id = this.state.editQuestion.id;
            }
            // window.location.assign('/questionnaire');
            this.props.Dispatch(QuestionnaireActions.createUnique(this.state.QuestionData));
            this.setState({ conformationModalMessage: null });
            // let data = "/" + `${this.state.editQuestion.id}` + "?expression=" + `${this.state.isChecked}`;
            // console.log(data);
            // this.props.Dispatch(QuestionnaireActions.expressionUpdate(data));
            // this.setState({ conformationModalMessage: null });

        }

        if (this.state.conformationModalType === 'DiscardUnSavedQuestion') {
            this.setState({ conformationModalMessage: null });
            //this.removeCancelButtoon();
            this.onPreviousEditClick();
        }
        this.setState({ conformationModalType: null, MidvaluesSlider: "" });
    },


    // sliderMinValueSlection(e) {
    //     e.target.value != '' ? this.refs.sliderMinValue.className = 'slider-value' : this.refs.sliderMinValue.className = 'slider-value error-border-bottom';
    //     this.setState({ MinValuesSlider: e.target.value });
    // },
    // sliderMaxValueSlection(e) {
    //     e.target.value != '' ? this.refs.sliderMaxValue.className = 'slider-value' : this.refs.sliderMaxValue.className = 'slider-value error-border-bottom';
    //     this.setState({ MaxValuesSlider: e.target.value });
    // },
    sliderMinValueSlection(e) {
        e.target.value != '' ? this.refs.sliderMinValue.className = 'slider-value' : this.refs.sliderMinValue.className = 'slider-value error-border-bottom';

        let maxval = this.state.MaxValuesSlider ? parseInt(this.state.MaxValuesSlider) : 0;
        let x = Math.ceil((parseInt(e.target.value) + maxval) / 2);

        this.setState({ MinValuesSlider: e.target.value }); // MidvaluesSlider: x
        this.state.MaxValuesSlider >= 2 && this.setState({ MidvaluesSlider: x }); // MidvaluesSlider: x
    },
    sliderMaxValueSlection(e) {
        e.target.value != '' ? this.refs.sliderMaxValue.className = 'slider-value' : this.refs.sliderMaxValue.className = 'slider-value error-border-bottom';

        let minval = this.state.MinValuesSlider ? parseInt(this.state.MinValuesSlider) : 0;
        let x = Math.ceil((minval + parseInt(e.target.value)) / 2);
        this.setState({ MaxValuesSlider: e.target.value });
        this.state.MinValuesSlider >= 0 && this.setState({ MidvaluesSlider: x });
    },

    closebox() {
        this.setState({ Okmessage: false, modal: false, conformationModalMessage: null });
    },
    remove_error(event) {
        event.target.className = 'inputText';
    },

    no_empty(event) {

        let value = event.target.value.trim();
        let isEmptyValue = validate.notEmpty(value);
        isEmptyValue ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    sliderAns_remove_error(e) {
        e.target.className = 'update-mail';
    },
    isValdSliderDescription(e) {
        e.target.value.trim().length > 0 ? e.target.className = 'update-mail' : e.target.className = 'update-mail error-border-bottom';
    },
    removeCancelButtoon() {
        this.refs.mainQuestion.value = '';
        this.setState({ selectedLabel: "Select Options", selectedIcon: '', errorMessage: null });
        this.setState({ previouslySelectedSubQuestionType: 0, selectedSubQuestionType: '0', QuestionData: null, checkBoxOptions: [], multiOptions: [], })
        this.props.router.push('/questionnaire')
    },
    mainQuestionmaxCharacterValue() {
        if (this.refs.mainQuestion.value.length === 500) {
            this.setState({
                Okmessage: "Max 500 characters reached.",

            })
            return false;
        }

    },
    maxCharacterValueSlider() {
        if (this.state.selectedSubQuestionType === '7' && this.refs.sliderMaxanswer.value.length === 140) {
            this.setState({
                Okmessage: "Max 140 characters reached.",

            })
            return false;
        }
    },
    maxCharacterValueSliderMid() {
        if (this.state.selectedSubQuestionType === '7' && this.refs.sliderMidanswer.value.length === 140) {
            this.setState({
                Okmessage: "Max 140 characters reached.",
            })
            return false;
        }
    },
    maxCharacterValueSliderMin() {
        if (this.state.selectedSubQuestionType === '7' && this.refs.sliderMinanswer.value.length === 140) {
            this.setState({
                Okmessage: "Max 140 characters reached.",

            })
            return false;
        }
    },
    render() {
        var style = {
            color: 'red'
        }

        //alert(this.state.addQuestionBool)
        return (
            <div className="dashboard-inner-content daily-survey">
                <Header screenIdentifier={screenIdentifier} />
                <button className="gray-button clear mod daily-save" data-toggle="modal" data-target="save" onClick={this.isValidQuestion} disabled={this.state.isQuestionEdit}>Save</button>
                {/* <button className="gray-button clear mod" onClick={this.removeCancelButtoon}>cancel</button> */}
                <div className="white-box questionnaire">
                    <div role="tabpanel">
                        {this.state.addQuestionBool &&
                            <div className="addingQuestions">
                                <div className="yourquestion">
                                    <div className="input-group input-field your-question">
                                        <input type="text" maxLength="500" className="inputText" required ref='mainQuestion' onFocus={this.remove_error} onBlur={this.no_empty} onChange={this.mainQuestionmaxCharacterValue} />
                                        <span className="floating-label" >Your question</span>
                                    </div>

                                    <div className="yourquestion-content">
                                        <div className="row">
                                            <div className="col-xs-9 padding-left-none">

                                                {(this.state.selectedSubQuestionType && this.state.selectedSubQuestionType === '1') &&
                                                    <ul className="dropdown-time">
                                                        <li>Time<span className="icon-time"></span></li>
                                                    </ul>
                                                }
                                                {(this.state.selectedSubQuestionType === '2') &&
                                                    <ul className="dropdown-time">
                                                        <li>Month,Date,Year<span className="icon-date"></span></li>
                                                    </ul>
                                                }
                                                {(this.state.selectedSubQuestionType === '3') &&
                                                    <ul>
                                                        <div className="card calculator">
                                                            <div id="checkBoxOptions-pane" ref="checkBoxOptions">
                                                                {
                                                                    _.map(this.state.checkBoxOptions, (v, i) => {

                                                                        return (<Addoptions id={i++} key={v.name + "_" + i} answer={v} onOptionChange={this.onOptionChange} onDelete={this.deletRow} />)
                                                                    })
                                                                }
                                                            </div>
                                                        </div>{this.state.checkBoxOptions && this.state.checkBoxOptions.length < 5 &&
                                                            <button className="addmoretext" onClick={this.onAddChild}><span className="icon-blue-arrow-ques"></span><span className="addmore-text">Add more option</span></button>
                                                        }

                                                    </ul>
                                                }
                                                {(this.state.selectedSubQuestionType === '4') &&
                                                    <ul className="dropdown-time paragraph">
                                                        <li>Long answer text</li>
                                                    </ul>
                                                }
                                                {(this.state.selectedSubQuestionType === '5') &&
                                                    <ul className="dropdown-time paragraph">
                                                        <li>Short answer text</li>
                                                    </ul>
                                                }
                                                {(this.state.selectedSubQuestionType === '6') &&
                                                    <ul className="radio-button">
                                                        <div id="children-pane" ref='multipleOptions'>
                                                            {
                                                                _.map(this.state.multiOptions, (v, i) => {
                                                                    return (<AddMultipleQuestions id={i} key={v.name + "_" + i} optionCounter={this.state.counter} answer={v} editQuestion={this.state.editQuestion} onOptionChangeMulti={this.onOptionChangeMulti} onDelete={this.deletRowMultiQuestion} onFollowChange={this.onFollowChange} />)

                                                                })
                                                            }
                                                        </div>
                                                        {this.state.multiOptions && this.state.multiOptions.length < 5 &&
                                                            <button className="addmoretext" onClick={this.onAddChildmulti} value='1'><span className="icon-blue-arrow-ques"></span><span className="addmore-text">Add more option</span></button>
                                                        }

                                                    </ul>
                                                }

                                                {(this.state.selectedSubQuestionType === '7') &&
                                                    <ul className="slider-options">


                                                        <li className="slider-values">
                                                            <div>
                                                                <input type='text' onBlur={this.sliderMax_remove_error} ref="sliderMinValue" className="slider-value" value={this.state.MinValuesSlider} disabled />
                                                                <input className="update-mail" placeholder="Option" type='text' maxLength="140" ref='sliderMinanswer' defaultValue={this.state.MinValuesSliderOpt} onFocus={this.sliderAns_remove_error} onBlur={this.isValdSliderDescription} onChange={this.maxCharacterValueSliderMin}></input>
                                                            </div>
                                                            <div>
                                                                <input type='text' onBlur={this.sliderMax_remove_error} ref="sliderMidValue" className="slider-value" value={this.midvaluesSlider()} disabled />
                                                                <input className="update-mail" placeholder="Option" type='text' maxLength="140" ref='sliderMidanswer' defaultValue={this.state.MidValuesSliderOpt} onFocus={this.sliderAns_remove_error} onBlur={this.isValdSliderDescription} onChange={this.maxCharacterValueSliderMid}     ></input>
                                                            </div>
                                                            <div>
                                                                <input type='text' ref="sliderMaxValue" className="slider-value" value={this.state.MaxValuesSlider} disabled />
                                                                <input className="update-mail" placeholder="Option" type='text' maxLength="140" ref='sliderMaxanswer' defaultValue={this.state.MaxValuesSliderOpt} onFocus={this.sliderAns_remove_error} onBlur={this.isValdSliderDescription} onChange={this.maxCharacterValueSlider}></input>
                                                            </div>
                                                            {/* {this.state.dailyServeyValue && <div>
                                                                <input type='text' ref="dailySliderValue" className="slider-value" value={this.state.dailyServeyValue} disabled />
                                                                <input className="update-mail" placeholder="Option" type='text' maxLength="140" ref='dailySliderValueanswer' defaultValue={this.state.dailyServeyValueOpt} onFocus={this.sliderAns_remove_error} onBlur={this.isValdSliderDescription} onChange={this.maxCharacterValueSlider}></input>
                                                            </div>}
                                                            {this.state.dailyServeyOneValue && <div>
                                                                <input type='text' ref="dailySliderValueOne" className="slider-value" value={this.state.dailyServeyOneValue} disabled />
                                                                <input className="update-mail" placeholder="Option" type='text' maxLength="140" ref='dailySliderValueOneanswer' defaultValue={this.state.dailyServeyOneValueOpt} onFocus={this.sliderAns_remove_error} onBlur={this.isValdSliderDescription} onChange={this.maxCharacterValueSlider}></input>
                                                            </div>}
                                                            {this.state.dailyServeyTwoValue && <div>
                                                                <input type='text' ref="dailySliderValueTwo" className="slider-value" value={this.state.dailyServeyTwoValue} disabled />
                                                                <input className="update-mail" placeholder="Option" type='text' maxLength="140" ref='dailySliderValueTwoanswer' defaultValue={this.state.dailyServeyTwoValueOpt} onFocus={this.sliderAns_remove_error} onBlur={this.isValdSliderDescription} onChange={this.maxCharacterValueSlider}></input>
                                                            </div>}
                                                            {this.state.dailyServeyThreeValue && <div>
                                                                <input type='text' ref="dailySliderValueThree" className="slider-value" value={this.state.dailyServeyThreeValue} disabled />
                                                                <input className="update-mail" placeholder="Option" type='text' maxLength="140" ref='dailySliderValueThreeanswer' defaultValue={this.state.dailyServeyThreeValueOpt} onFocus={this.sliderAns_remove_error} onBlur={this.isValdSliderDescription} onChange={this.maxCharacterValueSlider}></input>
                                                            </div>} */}
                                                        </li>
                                                    </ul>
                                                }
                                            </div>
                                            <div className="col-xs-3 padding-right-none">
                                                <div className="questionDropdown pull-right">
                                                    <div className="btn-group">
                                                        <div className="dropdown open">
                                                            <button className="button-drop"><span className={this.state.selectedIcon}></span> {this.state.selectedLabel}</button>
                                                            <ul className="dropdown-menu dropdown-menu-center">
                                                                {
                                                                    _.map(this.props.Answertype, (Data, key) => {
                                                                        if (key < 7) {
                                                                            return (
                                                                                <li key={key} data-value={Data.id} onClick={this.answerTypeHandler} >
                                                                                    <a key={key} data-value={Data.id} onClick={this.answerTypeHandler} > {Data.type}</a>
                                                                                </li>
                                                                            );
                                                                        }
                                                                    })
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.errorMessage &&
                                        <div className="error-message">
                                            <span style={style}>{this.state.errorMessage} </span>
                                        </div>
                                    }
                                </div>

                            </div>
                        }
                    </div>
                    <div className="tab-content">
                        <div role="tabpanel" className="tab-pane active">
                            {_.map(this.props.uniqe, (v, i) => {
                                if (this.state.editQuestion && this.state.editQuestion.id === v.id) {
                                    return
                                }
                                return <div key={i} className="input-group input-field your-question">
                                    <div className="addingQuestions">
                                        <div className="ques-edit pull-right">
                                            <button className="icon-edit" data-val={v.id} onClick={this.onEditClick}></button>
                                            {/* <button onClick={this.deleteSavedQuestionModal} className="notification-close" data-value={v.id}>X</button> */}
                                        </div>
                                        <div className="yourquestion saved-ques" >
                                            <div >
                                                <p>{v.name}</p>
                                                <ul className="increment-questions">
                                                    <li className="ques-gray">{v.answerType.type}</li>
                                                </ul>
                                                {v.answerType.id.toString() !== '7' && _.map(v.answer, (v1, i) => {
                                                    return <div className="padding-left-30" key={i}>
                                                        <p><span className="icon-add-more"></span><span className="followtext">{v1.name}</span></p>
                                                        {
                                                            _.map(v1.followQuestion, (followQue, i) => {
                                                                return <div className="padding-left-30" key={i}>
                                                                    <p>{followQue.name} </p>
                                                                    <ul className="increment-questions"><li className="ques-gray">{followQue.answerType.type}</li></ul>

                                                                    {followQue.answerType.id.toString() !== '7' &&
                                                                        _.map(followQue.answer, (followAns, i) => {
                                                                            return <div key={i}>
                                                                                <p><span className="icon-add-more"></span><span className="followtext">{followAns.name} </span></p>

                                                                            </div>
                                                                        })}
                                                                    {followQue.answerType.id.toString() === '7' && followQue.sliderConfiguration && followQue.sliderConfiguration.length &&
                                                                        <div>
                                                                            {followQue.sliderConfiguration.map((data, i) => {
                                                                                return (
                                                                                    <p key={i}>{data.value}</p>
                                                                                )
                                                                            })}
                                                                            {/* <p>{followQue.sliderConfiguration[0].data} </p>
                                                                                <p>{followQue.sliderConfiguration[0].value}</p>
                                                                                <p>Mid:{followQue.sliderConfiguration[1].data}</p>
                                                                                <p>{followQue.sliderConfiguration[1].value}</p>
                                                                                <p>Max:{followQue.sliderConfiguration[2].data}</p>
                                                                                <p>{followQue.sliderConfiguration[2].value}</p> */}
                                                                        </div>
                                                                    }
                                                                </div>
                                                            })}
                                                    </div>
                                                })}
                                                {v.answerType.id.toString() === '7' && v.sliderConfiguration && v.sliderConfiguration.length &&
                                                    <div>
                                                        {v.sliderConfiguration.map((data, i) => {
                                                            return (
                                                                <p key={i}>{data.value}</p>
                                                            )
                                                        })}
                                                        {/* <p>Min:{v.sliderConfiguration[0].data} </p>
                                                            <p>{v.sliderConfiguration[0].value}</p>
                                                            <p>Mid:{v.sliderConfiguration[1].data}</p>
                                                            <p>{v.sliderConfiguration[1].value}</p>
                                                            <p>Max:{v.sliderConfiguration[2].data}</p>
                                                            <p>{v.sliderConfiguration[2].value}</p> */}
                                                    </div>
                                                }


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                </div>
                <div> {this.state.Okmessage ? <ModalDialogCommon message={this.state.Okmessage} action={this.closebox} /> : ""}</div>
                <div> {this.state.conformationModalMessage ? <ModalDialogCommon message={this.state.conformationModalMessage} cancel="true" action2={this.closebox} action={this.onConfirm} /> : ""}</div>
            </div>
        );
    }
});
let mapStateToProps = (state) => {
    var daily = _.flatten(state.Questionnaire.QuestionnaireDaily);
    return {
        Answertype: state.Questionnaire.AnswerType,
        uniqe: daily

    };
};
let mapDispatchToProps = (dispatch) => ({
    QuestionnaireActions: bindActionCreators(QuestionnaireActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(Questionnaire));



/** WEBPACK FOOTER **
 ** ./src/components/questionnaireScreen/daily.js
 **/